import { TweenMax } from 'gsap';

export default function staggerFade(el) {
  const p = Array.from(el.querySelectorAll('p'));

  TweenMax.set(p, {
    y: 30,
    autoAlpha: 0,
  });

  return el;
}
